import { render, staticRenderFns } from "./ApplicationdetailsT.vue?vue&type=template&id=31b6c696&scoped=true&"
import script from "./ApplicationdetailsT.vue?vue&type=script&lang=js&"
export * from "./ApplicationdetailsT.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationdetailsT.vue?vue&type=style&index=0&id=31b6c696&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b6c696",
  null
  
)

export default component.exports